


































import { AnagraficaRequest } from "@/data/models/anagrafica.model";
import { AnagraficaService } from "@/data/services/anagrafica.service";
import { Component, Vue, Inject } from "vue-property-decorator";

@Component({})
export default class StpSearch extends Vue {
  @Inject("AnagraficaService")
  anagraficaService!: AnagraficaService;

  searchparam: AnagraficaRequest;

  constructor() {
    super();
    this.searchparam = new AnagraficaRequest();
    this.searchparam.stp = true;
  }

  get config() {
    if (process.env.VUE_APP_SEARCH) {
      return JSON.parse(process.env.VUE_APP_SEARCH);
    } else return {};
  }

  search() {
    this.$emit("search", this.searchparam);
  }

  reset() {
    this.searchparam = new AnagraficaRequest();
    this.searchparam.stp = true;
  }
}
